export namespace BILLING_TYPE {
    export const ONETIME      = "one-time"
    export const RECURRING    = "recurring"
    export const RETURN       = "return"
}

export type BILLING_TYPE = typeof BILLING_TYPE[keyof typeof BILLING_TYPE]



// WEBPACK FOOTER //
// ./src/state/invoice/InvoiceBillingType.ts